import { render, staticRenderFns } from "./DeclineOrderModal.vue?vue&type=template&id=56d8d054&scoped=true"
import script from "./DeclineOrderModal.vue?vue&type=script&lang=ts"
export * from "./DeclineOrderModal.vue?vue&type=script&lang=ts"
import style0 from "./DeclineOrderModal.vue?vue&type=style&index=0&id=56d8d054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8d054",
  null
  
)

export default component.exports